import StorageKeys from 'constants/StorageKeys';
import useAppDispatch from 'hooks/shared/store/useAppDispatch';
import useAppSelector from 'hooks/shared/store/useAppSelector';
import { FC, PropsWithChildren } from 'react';
import { useUpdateEffect } from 'react-use';
import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { authSelector } from 'selectors/modules/auth';
import { AuthStatus } from 'slices/modules/auth/authState';

const updateCookies = (sid: string | null): void => {
  let authCookie = `authToken=${sid};domain=${process.env.REACT_APP_SHARESPRO_COOKIES_DOMAIN}`;
  if (sid === null) {
    authCookie += ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
  }
  document.cookie = authCookie;
};

const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const authState = useAppSelector(authSelector);
  const dispatch = useAppDispatch();

  useUpdateEffect(() => {
    if (authState.status === AuthStatus.LoggedIn) {
      localStorage.setItem(StorageKeys.authSid, authState.sid);
      updateCookies(authState.sid);
    } else {
      dispatch(sharesproApi.util.resetApiState());
      localStorage.removeItem(StorageKeys.authSid);
      updateCookies(null);
    }
  }, [authState.status]);

  return <>{children}</>;
};

export default AuthProvider;
